import DeletionBusinessPage from './main.vue';
export default DeletionBusinessPage;
